import { type VirtualItem } from '@tanstack/react-virtual';
import { createContext, useContext } from 'react';

type VirtualMultiselectItemContextValue = {
  id: string;
  virtualItem: VirtualItem;
  disabled: boolean;
  selected: boolean;
};

export const VirtualMultiselectItemContext =
  createContext<VirtualMultiselectItemContextValue | null>(null);

export const useVirtualMultiselectItem = () => {
  const context = useContext(VirtualMultiselectItemContext);
  if (!context) {
    throw new Error(
      'useVirtualMultiselectItem must be used within a VirtualMultiselectItemContextProvider',
    );
  }
  return context;
};
